import { defineAsyncComponent } from 'vue';

const SETTINGS_PANELS = {
	'organization/extensions': defineAsyncComponent(() => import('#layers/global-settings/components/SettingsOverlay/panels/OrganizationExtensions.vue')),
	'account/profile': defineAsyncComponent(() => import('#layers/global-settings/components/SettingsOverlay/panels/AccountProfile.vue')),
	'account/access': defineAsyncComponent(() => import('#layers/global-settings/components/SettingsOverlay/panels/AccountAccess.vue')),
	'organization/workspaces': defineAsyncComponent(() => import('#layers/global-settings/components/SettingsOverlay/panels/OrganizationWorkspaces.vue')),
	'organization/members': defineAsyncComponent(() => import('#layers/global-settings/components/SettingsOverlay/panels/OrganizationMembers.vue')),
	'organization/general': defineAsyncComponent(() => import('#layers/global-settings/components/SettingsOverlay/panels/OrganizationGeneral.vue')),
	'organization/api-keys': defineAsyncComponent(() => import('#layers/global-settings/components/SettingsOverlay/panels/OrganizationApiKeys.vue')),
	'organization/service-accounts': defineAsyncComponent(() => import('#layers/global-settings/components/SettingsOverlay/panels/OrganizationServiceAccounts.vue')),
	'organization/sso': defineAsyncComponent(() => import('#layers/global-settings/components/SettingsOverlay/panels/OrganizationSso.vue')),
	'organization/audit-logs': defineAsyncComponent(() => import('#layers/global-settings/components/SettingsOverlay/panels/OrganizationAuditLogs.vue')),
	'organization/license': defineAsyncComponent(() => import('#layers/global-settings/components/SettingsOverlay/panels/OrganizationLicense.vue')),
} as const;

export type SettingsSection = keyof typeof SETTINGS_PANELS;

const DEFAULT_SECTION: SettingsSection = 'account/profile';

/** Build the `/~/…` backdrop-workspace path that opens the settings overlay at the given section. */
export function settingsOverlayPath(section: SettingsSection): string {
	return `/~/${section}`;
}

/** Resolve a `?settings=` value to a panel; unknown/empty falls back to the default section. */
export function panelFor(section: string | null) {
	return section && Object.hasOwn(SETTINGS_PANELS, section)
		? SETTINGS_PANELS[section as SettingsSection]
		: SETTINGS_PANELS[DEFAULT_SECTION];
}
